import { useCallback, useEffect, useRef } from "react";
//@ts-ignore
import InputField from '../base/premeeting/components/web/InputField';
export const useNextInput = () => {
    const inputRefs = useRef([]);
    const currentTabIndex = useRef(0);
    const registerInputRef = useCallback((inputEl) => {
        if (inputEl && !inputRefs.current.includes(inputEl)) {
            inputRefs.current.push(inputEl);
        }
    }, []);
    const handleOnKeyNext = (event) => {
        if (["Enter"].includes(event.key || event.code)) {
            event.preventDefault();
            const nextTabIndex = currentTabIndex.current + 1 > inputRefs.current.length ? inputRefs.current.length - 1 : currentTabIndex.current + 1;
            currentTabIndex.current = nextTabIndex;
            const nextElement = inputRefs.current[nextTabIndex];
            if (nextElement instanceof HTMLButtonElement || nextElement instanceof HTMLDivElement) {
                return nextElement.click();
            }
            if (nextElement instanceof InputField) {
                return nextElement === null || nextElement === void 0 ? void 0 : nextElement.focus();
            }
            return nextElement === null || nextElement === void 0 ? void 0 : nextElement.focus();
        }
    };
    useEffect(() => {
        document.addEventListener('keydown', handleOnKeyNext);
        return () => document.removeEventListener('keydown', handleOnKeyNext);
    }, []);
    useEffect(() => {
        var _a;
        const firstElement = (_a = inputRefs === null || inputRefs === void 0 ? void 0 : inputRefs.current) === null || _a === void 0 ? void 0 : _a[0];
        if (!firstElement || !(firstElement instanceof HTMLInputElement))
            return;
        firstElement === null || firstElement === void 0 ? void 0 : firstElement.focus();
    }, []);
    return {
        registerInput: registerInputRef,
        handleOnKeyNext
    };
};
